import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const DevicesSecondaryViewStore = GenericFieldFactory("DEVICES_SECONDARY_VIEW", null);